module.exports = __webpack_public_path__ + "static/media/user.3ddb2dc1.jpg";